import React, { useEffect, useState } from 'react';
import './CityDoctor.css';
import doctorImage from './telehealth from your city.jpg';

const CityDoctor = () => {
  const [showText, setShowText] = useState(false);
  const [showImage, setShowImage] = useState(false);

  const handleScroll = () => {
    const textContent = document.querySelector('.text-content');
    const imageContent = document.querySelector('.image-content');

    const textPosition = textContent.getBoundingClientRect().top;
    const imagePosition = imageContent.getBoundingClientRect().top;
    const screenHeight = window.innerHeight;

    if (textPosition < screenHeight && textPosition > 0) {
      setShowText(true);
    } else {
      setShowText(false);
    }

    if (imagePosition < screenHeight && imagePosition > 0) {
      setShowImage(true);
    } else {
      setShowImage(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section className="telehealthcare-section">
      <div className={`text-content ${showText ? 'show' : ''}`}>
        <h2>Telehealthcare from Your City’s Doctors</h2>
        <p>Access trusted healthcare from doctors in your own city. Your health, close to home.</p>
      </div>
      <div className={`image-content ${showImage ? 'show' : ''}`}>
        <img src={doctorImage} alt="Doctor" />
      </div>
    </section>
  );
};

export default CityDoctor;
